import Base from './condition-base'
import renderFields from './image-overlay-click.pug'

export default class ImageOverlayClick extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
